// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "page-about{display:block}page-about main-section{font-size:1.6rem}page-about aside-info{margin:0}", ""]);
// Exports
module.exports = exports;
